const experiences = [
    {
        title: 'Software Engineer',
        company: 'Kalangu - Ashesi',
        duration: 'May 2022 - Present',
        roles: [
            "Partnered with UI/UX team to design mockups using multiple iterations to increase usability & accessibility by 60%",
            "Translated wireframes to quality code associated with RESTFUL APIs for a responsive & interactive web application",
            "Worked effectively with state management tools like React Query to optimize its speed, storage, and scalability",
            "Oversaw a team of 3 to segment tasks and write reusable code in React.js to reduce code redundancy by 67%"
        ],
        extra: 'UI/UX - User Interface/User experience'
    },
    {
        title: 'Software Engineer',
        company: 'AnalogTeams',
        duration: 'February 2022 - May 2022',
        roles: [
            "Implemented exact replicas of design screens from Figma to responsive applications on mobile and web devices ",
            "Developed a mobile web application for community communications and broadcast using React.js and REST APIs",
            "Developed user communication features using Flutter for android and iOS devices which reduced bugs by 30%"
        ]
    },
    {
        title: 'Faculty Intern ',
        company: 'Ashesi University',
        duration: 'September 2021 - August 2022',
        roles: [
            "Worked closely with lecturers to prepare lessons to manage a few classes with over 40 students each" ,
            "Organized engaging revision and tutorial sessions for students which enabled at least 95% pass in each course",
            "Graded assignments with transparent & flexible marking schemes, alongside consistent student feedback provision"
        ]
    },

    {
        title: 'Software Engineer',
        company: 'Knack.it Corporation',
        duration: 'January 2020 - July 2021',
        roles: [
            "Transformed Adobe XD Wireframes to modernized & responsive web applications using Angular and REST APIs",
            "Co-developed a mario-like game in Unity integrated with machine learning modules for gamification in recruiting",
            "Developed a mobile application for user game management using Flutter which increased user satisfaction by 20%"
        ]
    },
    {
        title: 'Software Engineer Intern',
        company: 'Republic Bank',
        duration: 'June 2020 - August 2020',
        roles: [
            "Designed and developed an iOS and android mobile application for staff referrals",
            "Designed and developed a web application for the management of staff referrals",
            "Worked closely with the head of IT to collect data, implement and test application"
        ]
    },
    {
        title: 'Software Engineer Intern',
        company: 'AirtelTigo GH',
        duration: 'July 2018 - September 2018 ',
        roles: [
            "Built a java application to help engineers identify cell sites easily while on field",
            "Used macros and *VBA to simplify processes in Ms Excel which improved the company’s efficiency",
            "Analysed and reported on incidents at its cell sites across Ghana"
        ],
        extra: '*VBA - Visual Basic for Applications'
    }
]

export default experiences